<template>
  <div :style="{bottom: upBtn || fullFooter? '0' : '-' + getFooterHeight + 'px'}" class="footer">
    <b-btn class="toggle-btn" @click="upBtn = !upBtn" v-if="!fullFooter">
      <i v-if="!upBtn" class="fas fa-ellipsis-v fa-lg"></i>
      <i v-else class="fas fa-ellipsis-h fa-lg"></i>
    </b-btn>
    <footer
      :style="{background:config.footerBackgroundColor,color:config.footerFontColor,fontSize:config.footerFontSize}"
    >
      <b-row class="text-center mt-1 pb-2 pt-2">
        <b-col cols="12" md="3" offset-md="1">
          <router-link
            :to="'/' + companyName + '/QueueStatus'"
            @click.native="upBtn = false"
          >Podglad kolejek</router-link>
        </b-col>
        <b-col cols="12" md="3">
          <router-link
            :to="'/' + companyName + '/Reservation'"
            @click.native="upBtn = false; toReservation();"
          >Umawianie wizyt</router-link>
        </b-col>
        <b-col cols="12" md="3">
          <a href="http://qmspro.pl/">System kolejkowy QMS</a>
        </b-col>
      </b-row>
    </footer>
  </div>
</template>

<script>
export default {
  name: "customFooter",
  data() {
    return {
      fullFooter: true,
      upBtn: false
    };
  },
  methods: {
    resizeHandler() {
      var vm = this;
      vm.fullFooter = window.innerWidth > 992;
    },
    toReservation() {
      this.$store.dispatch("setKey");
    }
  },
  computed: {
    config: function() {
      return this.$store.getters.layoutConfig;
    },
    companyName: function() {
      return this.$route.params.companyName;
    },
    getFooterHeight: function() {
      return document.getElementsByClassName("footer")[0].offsetHeight;
    }
  },
  mounted() {
    var vm = this;
    window.addEventListener("resize", function() {
      vm.resizeHandler();
    });
    setTimeout(() => {
      vm.resizeHandler();
    }, 1000);
  }
};
</script>

<style scoped>
footer {
  bottom: 0;
  font-size: 18px;
  color: white;
}
footer .footer-content {
  color: inherit;
  margin: auto;
}

footer a {
  color: inherit;
}
footer .footer-content .nav-link {
  color: inherit;
}

footer .footer-content .nav-link.disabled:hover {
  cursor: default;
}
div.footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  transition: all 0.5s;
  overflow: hidden;
}
</style>

